import { mapActions, mapGetters } from "vuex";

export const crewMixin = {

    data() {
        return  {
            searchKey: 'all',
            searchValue: '',
            manning: 0,
            rank: 0,
            natl: 0
        }
    },

    methods: {
        ...mapActions([ 'getManningKeys', 'getRankKeys', 'getNatlKeys', 'getCrewList' ]),

        searchCrew() {
            let page = this.pagination.currentPage;
            let params = {
                page: page,
                searchKey: this.searchKey,
                searchValue: this.searchValue,
                manning: this.manningId,
                rank: this.rank,
                natl: this.natl
            };
            this.getCrewList(params);
        },
    }

}
